(() => {
  if (customElements.get('megamenu-element')) {
    return;
  }

  class MegamenuElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    init() {
      this.mobileBreakpoint = '(max-width: 1024px)';
      this.tabButtons = this.querySelectorAll('[data-tab-button]');
      this.tabs = this.querySelectorAll('[data-tab-id]');
      this.backButtons = this.querySelectorAll('[data-button-tab-back]');
    }

    attachEvents() {
      this.tabButtons.forEach((tabButton) => {
        tabButton.addEventListener('mouseenter', () => {
          const isMobileDevices = window.matchMedia(
            this.mobileBreakpoint,
          ).matches;

          if (isMobileDevices) {
            return;
          }

          this.updateTab(tabButton);
        });

        tabButton.addEventListener('click', (event) => {
          event.preventDefault();

          const isMobileDevices = window.matchMedia(
            this.mobileBreakpoint,
          ).matches;

          if (!isMobileDevices) {
            return;
          }

          this.updateTab(tabButton);
        });
      });

      this.backButtons.forEach((backButton) => {
        const targetTab = backButton.closest('[data-tab-id]');

        backButton.addEventListener(
          'click',
          this.tabClose.bind(this, targetTab),
        );
      });
    }

    updateNavigationActiveState(targetButton) {
      this.tabButtons.forEach((button) => {
        button.classList.toggle('is-active', button === targetButton);
      });
    }

    updateTab(tabButton) {
      const targetTab = this.querySelector(
        `[data-tab-id="${tabButton.dataset.tagetTabId}"]`,
      );

      if (!targetTab) {
        return;
      }

      this.updateNavigationActiveState(tabButton);
      this.changeTab(targetTab);

      const header = document.querySelector('section-header');

      if (header) {
        header.updateNavItemsActiveState(tabButton.dataset.handle);
      }
    }

    changeTab(targetTab) {
      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      if (isMobileDevices) {
        this.tabs.forEach((tab) => {
          tab.classList.toggle('is-open', tab === targetTab);

          if (tab === targetTab) {
            bodyScroll.unlock(this.querySelector('[data-overflow]'));

            bodyScroll.lock(tab.querySelector('[data-tab-overflow]'));
          }
        });
      }

      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === targetTab);
      });
    }

    tabClose(targetTab) {
      targetTab.classList.remove('is-open');

      bodyScroll.unlock(targetTab.querySelector('[data-tab-overflow]'));

      bodyScroll.lock(this.querySelector('[data-overflow]'));
    }

    open() {
      this.classList.add('is-open');

      bodyScroll.lock(this.querySelector('[data-overflow]'));
    }

    close() {
      this.classList.remove('is-open');

      this.tabs.forEach((tab) => tab.classList.remove('is-open'));

      bodyScroll.clear();

      const predictiveSearchMobile = this.querySelector(
        'predictive-search-mobile',
      );

      if (predictiveSearchMobile) {
        predictiveSearchMobile.close(true);
      }
    }
  }

  customElements.define('megamenu-element', MegamenuElement);
})();
